import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import axios from 'axios'
import InitPage from "@/pages/InitPage";
import LoginPage from "@/pages/LoginPage";
import ConsolePage from "@/pages/console/ConsolePage";
import util from './util';
import bizutil from '@/bizutil';
import dialogutil from './dialogutil';

import Vuex from 'vuex'

import ElTableInfiniteScroll from "el-table-infinite-scroll";
Vue.directive("el-table-infinite-scroll", ElTableInfiniteScroll);

Vue.use(ElementUI)
Vue.use(VueRouter)

Vue.use(Vuex)

// 定义全局路由器
const router = new VueRouter({
  routes: [
    { name: "init", path: "/", component: InitPage }, // 初始化页面
    { name: "login", path: "/login", component: LoginPage }, // 登录页面
    { name: "console", path: "/console", alias: "/console/*", component: ConsolePage, meta: { needAuth: true } }, // 控制台页面，通过meta携带额外配置
  ]
});

// 重定义路由器的push方法，以避免“Navigating to current location ("/") is not allowed”错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

// 全局路由器准备好了就直接跳到初始化页面，初始化页面完成初始化逻辑后会自动返回到当前要访问的路径
router.onReady(() => {
  // 将全局路由器存下来，方便用
  util.saveGlobalRouter(router);

  // 跳到初始化页面，初始化页面完成初始化之后会自动返回到当前本来要访问的路径
  router.push({ name: "init" })

  // 为全局路由器定义前置守卫
  router.beforeEach((to, from, next) => {
    // 如果目标页面需要登录状态才能访问，则，如当前处于未登录状态，就自动跳转到登录页面
    if (to.meta.needAuth) {
      let loginUser = bizutil.getLoginUser();
      if (!loginUser || loginUser.isLogin != "1") {
        util.gotoLoginPage();
      }
      if (loginUser != null && loginUser.isNeedUpdatePassword) {
        /**
        * 打开必须修改密码弹窗
        * 需要修改密码
        * 弹出密码修改框
        * 密码弹窗不允许取消和关闭 data:{mustUpdate:true}
        */
        let closedCallback = () => {
          loginUser.isNeedUpdatePassword = false
          util.storeToLocalStorage(
            "loginUser",
            loginUser,
            60 * 60 * 24 * 7
          );
        }
        setTimeout(() => {
          dialogutil.open("ChangePasswordDialog", { closedCallback, data: { mustUpdate: true } })
        }, 100);
      }
    }

    next();
  })
})

axios.interceptors.request.use(config => {
  if (config.url.search(util.getBackendApiBase()) != -1) {
    config.headers["item-name-style"] = util.getFromLocalStorage("item-name-style")
  }
  return config;
})

const store = new Vuex.Store({})

dialogutil.saveGlobalStore(store)

Vue.prototype.$util = util
Vue.prototype.$dialogutil = dialogutil
Vue.prototype.$bizutil = bizutil

new Vue({
  el: '#app',
  render: h => h(App),
  router: router,
  store: store
})